var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "icon",
      attrs: {
        t: "1658374478112",
        viewBox: "0 0 1024 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "p-id": "2720",
        width: "200",
        height: "200",
      },
    },
    [
      _c("path", {
        attrs: {
          "stroke-width": "6",
          d: "M972.384 272.064a27.584 27.584 0 0 0-38.976 0L512 693.472 90.592 272.064A27.584 27.584 0 0 0 51.616 311.04l440.896 440.896a27.52 27.52 0 0 0 38.976 0L972.384 311.04a27.584 27.584 0 0 0 0-38.976z",
          fill: "",
          "p-id": "2721",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }